<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-06-25 13:14:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 15:08:54
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='$store.state.iconstatus'
                       :showReturn='false'
                       @handleEdit='change'
                       @handleDel='remove'></mrc_ess_iconGroup>

    <group v-if="$store.state.group_name"
           @changeReadonly='change'
           :readonly='readonly'>
    </group>
    <Levelcomponents v-else
                     @changeReadonly='change'
                     :readonly='readonly'></Levelcomponents>
  </div>
</template>   

<script>
import Levelcomponents from './modules/Levelcomponents'
import group from './modules/group'
import { delete_postgrades_group, delete_postgrades } from '@/service/api/postgrades.js'
export default {
  components: {
    Levelcomponents, group
  },
  props: {},
  data () {
    return {
      readonly: false,
    };
  },
  created () { },
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  methods: {
    change () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', !this.$store.state.iconstatus)  //行内进图标显示
    },
    remove () {  //删除
      this.$myConfirm({
        content: this.$t('message_Confirm_the_deletion')
      }).then(res => {
        if (this.$store.state.group_name) {
          delete_postgrades_group({
            group_name: this.$store.state.group_name
          }).then(res => {
            if (res.code == 200) {
              this.$Message({ text: this.$t('message_The_deletion_was_successful') })
              this.$router.push({
                name: 'Post_level_management',
                params: {
                  type: 'del'
                }
              })
            }
          })
        }
        else {
          delete_postgrades({
            uuid: this.$store.state.uuid
          }).then(res => {
            if (res.code == 200) {
              this.$Message({ text: this.$t('message_The_deletion_was_successful') })
              this.$router.push({
                name: 'Post_level_management',
                params: {
                  type: 'del'
                }
              })
            }
          })
        }
      }).catch(err => { })
    },
  },
  computed: {},
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_job_level'
          this.$store.commit('set_page_title', 'label_edit_job_level')
        }
        else {
          this.$route.meta.title = 'label_view_job_level'
          this.$store.commit('set_page_title', 'label_view_job_level')
        }
      }, immediate: true
    }
  },
};
</script>

<style scoped>
.icon {
  padding: 15px 10px;
  color: white;
}
.icon-box {
  position: fixed;
  top: 75px;
  right: 30px;
}
.btn-icon {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: primary;
}
</style>
